function toggleMenu(header, html) {
    header.classList.toggle('open');
    html.classList.toggle('noscroll');
}

function toggleDropdowns(e, item) {
    if (window.innerWidth < 960) {
        e.preventDefault();
        item.parentElement.classList.toggle('sub-menu-open');
    }
}

export default () => {
    const header = document.getElementById('masthead');
    const menuButton = document.getElementById('menu-btn');
    const html = document.getElementById('html');
    const dropdowns = Array.from(header.querySelectorAll('.menu-item-has-children > a'));
    if (menuButton) {
        menuButton.addEventListener('click', () => {
            toggleMenu(header, html);
        });
    }
    if (dropdowns) {
        dropdowns.forEach(item => {
            const listItem = document.createElement('li');
            const cloneTopLink = item.cloneNode(true);
            listItem.appendChild(cloneTopLink);
            item.parentElement.querySelector('.sub-menu').prepend(listItem);
            item.addEventListener('click', (e) => {
                toggleDropdowns(e, item);
            });
        });
    }
};